module.exports = __webpack_public_path__ + "static/media/play_arrow_blue.7f7bb120.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/play_arrow_blue.svg
// module id = 50
// module chunks = 0